import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";

import {
  setIsSendRequestToBMCPopupOpen,
  clearSendRequestToBMCPopupData,
  setSendRequestToBMCPopupData,
  sendRequestToBMC,
} from "src/redux/slices/bmcWithRatingSlice";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { ReactComponent as ExportNotesIcon } from "../../../../assets/icons/export_notes.svg";
import { MAX_TEXT_FIELD_SIZE } from "src/resources/constant";

import { useEffect } from "react";
import {
  getBMCTemplates,
  setBMCTemplates,
} from "src/redux/slices/civilDefenseSlice";
import { isNullOrWhiteSpace } from "src/utils/helpers";

const SendRequestToBMCPopup = () => {
  const dispatch = useDispatch();

  const bmcTemplates = useSelector(
    (state: any) => state.civilDefense.bmcTemplates
  );
  const { isSendRequestToBMCPopupOpen, sendRequestToBMCPopupData } =
    useSelector((state: any) => state.bmcWithRating);

  const { t } = useTranslation(["common", "registration"]);

  function closePopup(): void {
    dispatch(setIsSendRequestToBMCPopupOpen(false));
    dispatch(clearSendRequestToBMCPopupData());
  }
  const { id } = useSelector(
    (state: any) => state.bmcWithRating.bmcWithRatingDetailsPopupData
  );
  function handleSendRequestToBMC(event: any): void {
    dispatch(sendRequestToBMC() as any).then(() => {
      closePopup();
    });
  }

  useEffect(() => {
    dispatch(setBMCTemplates([]) as any);
    if (id) {
      dispatch(getBMCTemplates(id) as any);
    }
  }, [dispatch, id]);

  const handleFieldChange = (e: any) => {
    var name = "";
    var value = "";
    value = e.target.value;
    name = e.target.name;
    var updatedDetails = { ...sendRequestToBMCPopupData, [name]: value };
    updatedDetails = { ...updatedDetails, ["bmcId"]: id };

    if (name === "templateId") {
      var template = bmcTemplates.find(
        (t: { id: any }) => t.id?.toString() === value?.toString()
      );

      {
        if (template) {
          updatedDetails = { ...updatedDetails, ["body"]: template.body };
          updatedDetails = { ...updatedDetails, ["subject"]: template.subject };
        }
      }
    }
    dispatch(setSendRequestToBMCPopupData(updatedDetails));
  };
  return (
    <Dialog
      visible={isSendRequestToBMCPopupOpen}
      onHide={closePopup}
      header={t("sendRequestToBMC")}
      headerClassName="popup-header"
      className="maintenance-requests-details-popup send-request-to-owner-popup"
    >
      <div className="pt-3">
        <div className="form-group d-flex flex-column mb-3">
          <label htmlFor="typeOfApproval">{t("template")}</label>
          <Dropdown
            id="templateId"
            name="templateId"
            value={sendRequestToBMCPopupData.templateId}
            optionValue={"id"}
            optionLabel={"name"}
            onChange={handleFieldChange}
            options={bmcTemplates}
            placeholder={t("selectTemplate")}
            className="w-50 mb-2"
            panelClassName="status-dropdown-panel"
          />
        </div>
        <div className="form-group d-flex flex-column mb-3">
          <label htmlFor="requestReferenceNumber" className="required">
            {t("subject")}
          </label>
          <InputText
            name="subject"
            placeholder={t("subjectPlaceHolder")}
            className="w-50 mb-2"
            value={sendRequestToBMCPopupData.subject}
            onChange={handleFieldChange}
            maxLength={MAX_TEXT_FIELD_SIZE}
          />
        </div>
        <div className="form-group d-flex flex-column">
          <label htmlFor="description" className="required">
            {t("body")}
          </label>
          <InputTextarea
            id="body"
            name="body"
            className="mb-2 w-100"
            placeholder={t("bodyPlaceHolder")}
            value={sendRequestToBMCPopupData.body}
            onChange={handleFieldChange}
            rows={7}
          />
        </div>
        <div className="d-flex justify-content-end align-items-center gap-2 mt-4 send-request-to-owner-footer">
          <Button
            label={t("cancel")}
            className="light-primary-btn m-0"
            onClick={closePopup}
          />
          <Button
            label={t("sendRequest")}
            className="edit-btn primary-btn m-0"
            icon={<ExportNotesIcon />}
            onClick={handleSendRequestToBMC}
            disabled={
              isNullOrWhiteSpace(sendRequestToBMCPopupData.bmcId) ||
              isNullOrWhiteSpace(sendRequestToBMCPopupData.subject) ||
              isNullOrWhiteSpace(sendRequestToBMCPopupData.body)
            }
          />
        </div>
      </div>
    </Dialog>
  );
};

export default SendRequestToBMCPopup;
